/**
 * Stap 1: welkom. Met een les: de titel van de tekst en de knop om te gaan
 * lezen. Zonder les: dat er nog niets klaarstaat. In een groepsles (stap 23)
 * ook welk deel de leerling leest en met wie hij in een groepje zit.
 *
 * Is de woordenoefening er (stap 29, `les.woorden`: de woordenlijst op zijn
 * niveau is klaar), dan staat er ook een knop om eerst de woorden te oefenen
 * (onOefen); niet bij de vragen.
 *
 * Was de leerling al begonnen (herladen, of een volgende keer ingelogd), dan
 * zegt het welkom dat hij verder gaat (`verder`): met het lezen ('lezen'),
 * of met de vragen ('vragen'). Tot 1 november kwam hij dan meteen bij de
 * tekst, zonder welkom.
 */
import React from 'react';
import { ChevronRight, Shapes } from 'lucide-react';
import { Draaier } from '../../../components/Laden';
import { AnnaMariaFoto } from '../onderdelen/AnnaMaria';
import { Groepje } from '../onderdelen/Groepje';
import { stijlen } from '../stijlen';

function Aankondiging({ les, verder }) {
  const titel = <strong style={{ color: 'var(--accent)' }}>{les.text_titel}</strong>;
  if (verder === 'vragen') {
    return (
      <>
        Je gaat verder met de vragen over de tekst {titel}.
        <br /><br />
        De tekst staat ernaast, dan kan je terugkijken.
        <br /><br />
        Succes!
      </>
    );
  }
  return (
    <>
      {les.groepsles ? (
        <>
          {verder ? <>Je gaat verder met het lezen van jouw deel van {titel}.</> : <>Je gaat een deel van {titel} lezen.</>}
          <br /><br />
          Lees het goed: straks vertel jij je groepje wat er in jouw deel staat, en maken jullie er samen één
          verhaal van.
        </>
      ) : (
        verder ? <>Je gaat verder met het lezen van de tekst {titel}.</> : <>Je gaat de tekst {titel} lezen.</>
      )}
      {les.woorden && !verder && (
        <>
          <br /><br />
          Wil je eerst {les.woorden.aantal} woorden uit de tekst oefenen? Dan kan dat hieronder.
        </>
      )}
      <br /><br />
      Als je wilt kan je mijn hulp inschakelen.
      <br /><br />
      Veel leesplezier!
    </>
  );
}

export function Welkom({ naam, les, verder, bezig, onBegin, onOefen }) {
  const knop = verder === 'vragen' ? 'Ga verder met de vragen' : verder ? 'Ga verder met lezen' : 'Begin met lezen';
  const oefenen = Boolean(les?.woorden && onOefen && verder !== 'vragen');
  const klaarGeoefend = oefenen && les.woorden.gemeten >= les.woorden.aantal;
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
      <div className="card text-center" style={{ padding: '60px 40px' }}>
        <AnnaMariaFoto />
        {!les ? (
          <>
            <h1>Welkom, {naam}</h1>
            <p className="text-muted mt-16">
              Er staat nog geen tekst voor je klaar.
              <br />
              Vraag je leerkracht om een sessie te starten.
            </p>
          </>
        ) : (
          <>
            <h1>{verder ? `Welkom terug, ${naam}` : `Hallo ${naam}`}</h1>
            <div style={{
              background: stijlen.annaMariaVerloop,
              borderRadius: 12,
              padding: 20,
              marginTop: 20,
              maxWidth: 500,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}>
              <p style={{ fontSize: 18, lineHeight: 1.6, color: 'var(--inkt)' }}>
                <Aankondiging les={les} verder={verder} />
                <br />
                <em>Anna Maria</em>
              </p>
            </div>
            <Groepje groepsles={les.groepsles} style={{ maxWidth: 500, margin: '16px auto 0' }} />
            <div className="mt-24" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              {oefenen && (
                <button className="btn btn-secondary" onClick={onOefen} disabled={bezig} data-testid="oefen-woorden"
                  style={{ padding: '16px 28px', fontSize: 18 }}>
                  <Shapes size={20} /> {klaarGeoefend ? 'Oefen de woorden nog een keer' : 'Oefen eerst de woorden'}
                </button>
              )}
              <button
                className="btn btn-primary"
                onClick={onBegin}
                disabled={bezig}
                style={{ padding: '16px 32px', fontSize: 18, opacity: bezig ? 0.7 : 1 }}
              >
                {bezig ? <><Draaier grootte={20} /> We halen de tekst op...</> : <>{knop} <ChevronRight size={20} /></>}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
